module.exports = "<div class=editor-wrapper ng-model=$root.editorValue ui-ace=\"{\n  useWrapMode : true,\n  mode: 'yaml',\n  onLoad: aceLoaded,\n  onChange: aceChanged}\"> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./views/editor/editor.html
 ** module id = 280
 ** module chunks = 0
 **/